import { ApprovalOption } from "./AnnualWheel.types";

export function isApprovalRequired(option: ApprovalOption | undefined) {
    return option === ApprovalOption.ApprovalRequiredByResponsible && option !== undefined;
}
